<template>
  <tg-layout>
    <div style="background:white;">
      <tg-nodata isFixing :breadcrumb="breadcrumb"></tg-nodata>
    </div>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgNodata from "@/components/TgNodata";

export default {
  components: {
    TgLayout,
    TgNodata,
  },
  data() {
    return {
      breadcrumb: '',
    };
  },
  created(){
    if(this.$route.params.breadcrumb){
      this.$route.params.breadcrumb.forEach(element=>{
        this.breadcrumb += this.$t(element)+'>';
      });
    }

    if(this.breadcrumb != ''){
      this.breadcrumb = this.breadcrumb.slice(0,-1);
    }
  }
};
</script>